<template>
  <el-aside
    width="201px"
    :style="{
    position: 'fixed',
    height: '100vh',
    left: 0,
    overflow: 'hidden',
    boxSizing: 'border-box',
    }"
    class="background"
  >
    <div class="sider-menu-block">
      <el-menu class="menu" text-color="color: rgb(33, 33, 33);" :unique-opened="true" @select="onSelect">
        <template v-for="item,i in menuList">
          <el-submenu :index="i.toString()">
            <template slot="title">
              <i :class="item.icon"></i>
              {{(item.name)}}
            </template>
            <el-menu-item
              :index="i+'-'+j"
              v-if="!child.moduleList"
              v-for="child,j in item.moduleList"
              :key="j"
            >{{child.name}}</el-menu-item>
          </el-submenu>
        </template>
      </el-menu>
      <span
        style="color:rgb(33, 33, 33);position: relative;left: 15px;bottom: -80px;"
      >闽ICP备19019473号-2</span>
    </div>
  </el-aside>
</template>
<script>
export default {
  name: "SiLayoutLeft",
  data() {
    return {
      projectName: "线上点灯管理系统",
      menuBlockHeight: 0,
      menuList: [],
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  mounted() {
    this.menuList = JSON.parse(window.localStorage.getItem("menusList"));
  },
  methods: {
    onSelect(name) {
      // console.log('name', name)
      let menuList = this.menuList;
      let flag = typeof name === "number";
      let path = "/";
      let displayName = "";
      if (flag) {
        path = menuList[name].path;
        name = menuList[name].name;
      } else {
        let arr = name.split("-");
        console.log("arr", arr);
        if (arr.length === 2) {
          // 第二层数据
          path = menuList[arr[0]].moduleList[arr[1]].path;
          name = menuList[arr[0]].moduleList[arr[1]].name;
        }
      }
      this.$router.push(path);
    },
  },
};
</script>

<style lang="less" scoped>
.background {
  background-image: url("../../../src/assets/left_bg.png") !important;
}
.sider-menu-block {
  width: 218px;
  overflow: scroll;
  height: 100%;
  .menu {
    background-color: #d28b52;;
  }
  .ivu-menu {
    width: 200px !important;
    background-color: #d28b52;
  }
}
.el-menu-item:hover {
  background: rgb(210, 139, 82) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Layout/layout-left.vue